import { MiraLogo } from "@recruiter/shared";

import { initials } from "../../lib/format";
import { useSellerStore } from "../../lib/store/seller-store";
import { DebugToggle } from "../seller/debug-toggle";
import { BarsIcon } from "./icons";

// The talent page's one bar: the brand (back to the cards alone), the Pro insights, who
// they are, and the tester's debug toggle. Their preferences live in the page's left column
// (`PreferencesSidebar`).
export function TalentTopbar() {
  const sellerId = useSellerStore((s) => s.activeSellerId);
  const setSelectedThread = useSellerStore((s) => s.setSelectedThread);
  const setInsightsOpen = useSellerStore((s) => s.setInsightsOpen);
  const clearActiveSeller = useSellerStore((s) => s.clearActiveSeller);

  return (
    <header className="sl-topbar">
      <button
        type="button"
        className="sl-rail__home"
        onClick={() => setSelectedThread(null)}
        title="All your projects"
      >
        <MiraLogo variant="solo" className="sl-rail__logo" title="Mira" />
        <span className="sl-rail__tag">for talent</span>
      </button>
      <span className="sl-topbar__spacer" />
      <button
        type="button"
        className="sl-pro-btn"
        onClick={() => setInsightsOpen(true)}
        aria-haspopup="dialog"
      >
        <BarsIcon size={16} />
        <span>Insights</span>
        <span className="sl-pro-badge">Pro</span>
      </button>
      <span className="sl-topbar__me">
        <span className="sl-avatar" aria-hidden="true">
          {initials(sellerId)}
        </span>
        <span className="sl-topbar__name" title={sellerId}>
          {sellerId}
        </span>
        <button type="button" className="sl-link" onClick={clearActiveSeller}>
          Switch
        </button>
      </span>
      <DebugToggle />
    </header>
  );
}
